<template>
    <div>
        <v-card class="score-chart ma-1">
            <v-container>
                <v-card-title>
                    <span class="caption-font white--text"><v-avatar size="40" class="rebooking mr-4"><v-icon color="white">mdi-home-switch-outline</v-icon></v-avatar>Rebookings</span>
                </v-card-title>
                <span class="br_medium"></span>
                <v-row class="white--text ml-4 mb-6">
                    <table style="width:80%">
                        <tr v-for="rebooking in rebookings" :key="rebooking.key">
                            <td class="td_markup_xl">{{ rebooking.text }}</td>
                            <td style="text-align: right;" class="td_markup_xl">{{ rebooking.num }}</td>
                        </tr>
                    </table>
                </v-row>
                <v-divider color="white"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="openSubScreen()">
                                <v-icon>mdi-open-in-app</v-icon>
                            </v-btn>
                        </template>
                        <span style="text-align: right;">Rebookings overview...</span>
                    </v-tooltip>
                </v-card-actions>
            </v-container>
        </v-card>
    </div>
</template>
<script>

import { bus } from "../../../../main";

export default {
    props: {
        gebr: {
            type: Object,
            default: () => ({}),
        }
    },
    components: {
    },
    data() {
        return {
            rebookings: [],
        }
    },
    created() {
        this.getRebookingsOverview();
        bus.$on("refresh", (data) => {
            console.log("refresh received for rebookings " + data);
            this.getRebookingsOverview();
        });
    },
    methods: {
        openSubScreen() {
            let route = this.$router.resolve({ path: '/task/customer_success/homb/homb_overview/user:' + this.gebr.gebr_xencrid }); 
            window.open(route.href, '_blank');

        },
        getRebookingsOverview() {
            this.$axios
                .post("ares/json/ares/syst/dashboard/getRebookingsOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRebookingsOverview"
                    },
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.rebookings = res.data.getRebookingsOverview;
                    }
                })
                .finally(() => {
                });
        },
    }
}
</script>
<style scoped>
    .score-chart {
        background: url('../assets/d_green_gradient.png') !important;
        background-size: cover !important;
    }

    .br_medium {
        display: block;
        margin-bottom: 1em;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .td_markup_xl {
        font-size: 17px !important;
        line-height: 25px !important;
    }
    .rebooking {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }

</style>